import { FilterValue } from 'models/FilterValue';
import { FilterValueWithChildren } from 'models/FilterValueWithChildren';

export const isFilterValueWithChildren = (
  value: FilterValue | FilterValueWithChildren
): value is FilterValueWithChildren => {
  return Boolean((value as FilterValueWithChildren).subValues);
};
